<div style="width: 600px">
    <h3 mat-dialog-title style="padding-top: 15px">
        <i class="fa fa-question-circle"></i> &nbsp; Mortgage Analytics Help
    </h3>
    <div mat-dialog-content>
        <div class="contact-details" style="padding-top: 10px">
            <p *ngIf="knowledgeBase">
                <b>Knowledge Base: </b>
                <a (click)="clickKnowledgeBaseUrl()" style="cursor: pointer">{{
                    knowledgeBase.baseUrl
                }}</a>
            </p>
        </div>

        <!-- Always display support for base clients -->
        <ng-container *ngIf="isBaseClient; else fullClientSupport">
            <p><b>Support</b></p>
            <p>
                Monday-Friday 8:30am-5:30pm Eastern<br />
                478-202-2222, dial 2 for support<br />
                <a href="mailto:mortgageanalytics@ncino.com">mortgageanalytics&#64;ncino.com</a>
            </p>
        </ng-container>

        <!-- Only display support for full clients if the current user is a PowerUser -->
        <ng-template #fullClientSupport>
            <p *ngIf="!isPowerUser && primaryContactEmail">
                <b>Support Contact: </b>
                <a [href]="supportLink">{{ primaryContactEmail }}</a>
            </p>

            <p *ngIf="isPowerUser"><b>Support</b></p>
            <p *ngIf="isPowerUser">
                Monday-Friday 8:30am-5:30pm Eastern<br />
                478-202-2222, dial 2 for support<br />
                <a href="mailto:mortgageanalytics@ncino.com">mortgageanalytics&#64;ncino.com</a>
            </p>
        </ng-template>

        <div *ngIf="losData">
            <ng-container *ngIf="isPowerUser || isSuperUser">
                <p><b>Updates from LOS</b></p>
                <p>
                    Last 24 Hours: {{ losData.numOfInserts | number : '1.0' : 'en-US' }} loans
                    added, {{ losData.numOfUpdates | number : '1.0' : 'en-US' }} loans updated
                </p>
            </ng-container>
        </div>

        <div class="version-area">
            <p><b>nCino Mortgage Analytics Release Information</b></p>
            <p>Web Version: v2025.07.847</p>
            <p>API Version: v{{ version }}</p>
        </div>
    </div>
    <div mat-dialog-actions class="mat-custom-dialog-actions">
        <button mat-button class="button-gray" (click)="onNoClick()">Close</button>
    </div>
</div>
